import Data from './Data';

const InfoboxBlockSidebar = (props) => {
  return <Data {...props} />;
};

export default InfoboxBlockSidebar;
